import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex shrink-0 items-center gap-1 text-[10px] uppercase" }

import { CardTitle } from '@/components/ui/card';
    import { columns } from '@/tables/columns/bank';
    import { DatePicker } from '@/components/ui/form';
    import { getLocalTimeZone, today } from '@internationalized/date';
    import { Head } from '@inertiajs/vue3';
    import { ref, computed } from 'vue';
    import { Separator } from '@/components/ui/separator';
    import { useI18n } from 'vue-i18n';
    import { usePage } from '@inertiajs/vue3';
    import { usePermissions } from '@/composables/usePermissions';
    import { useQuery } from '@tanstack/vue-query';
    import AppLayout from '@/layouts/AppLayout.vue';
    import axios from 'axios';
    import ConnectBank from '@/components/bank/ConnectBank.vue';
    import DataTable from '@/components/datatable/DataTable.vue';
    import DataTableToolbarActions from '@/components/datatable/DataTableToolbarActions.vue';
    import DisconnectBank from '@/components/bank/DisconnectBank.vue';
    import HoverInfo from '@/components/HoverInfo.vue';
    import PageCard from '@/components/PageCard.vue';
    import Permission from '@/enums/Permission';
    import QueryKey from '@/enums/QueryKey';
    import type { SharedData, BreadcrumbItem } from '@/types';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'Bank',
  props: {
    link: {},
    isConnected: { type: Boolean }
  },
  setup(__props: any) {

    const props = __props;

    const { t } = useI18n();
    const { hasPermission } = usePermissions();
    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);
    const perDate = ref(today(getLocalTimeZone()));

    const breadcrumbs: BreadcrumbItem[] = [
        {
            title: 'menu.bank',
            href: route('v2.bank.index'),
        },
    ];

    const { isPending, data } = useQuery({
        queryKey: [QueryKey.BANK, selectedCompanyId, perDate],
        queryFn: getBank,
    });

    async function getBank() {
        const { data } = await axios.get(route('v2.bank.table', selectedCompanyId.value), {
            params: {
                per_date: perDate.value,
            },
        });
        return data.data;
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Head), {
      title: _unref(t)('viia.header')
    }, null, 8, ["title"]),
    _createVNode(AppLayout, {
      breadcrumbs: breadcrumbs,
      "require-selected-company": ""
    }, {
      default: _withCtx(() => [
        (_unref(hasPermission)(_unref(Permission).BANK_VIEW))
          ? (_openBlock(), _createBlock(PageCard, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(DataTable, {
                  "table-key": _unref(QueryKey).BANK,
                  columns: _unref(columns),
                  data: _unref(data),
                  loading: _unref(isPending),
                  "default-column-visibility": {
                    id: false,
                    automatic_transfer: false,
                }
                }, {
                  title: _withCtx(() => [
                    _createVNode(_unref(CardTitle), null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('viia.header')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  actions: _withCtx(() => [
                    _createVNode(DataTableToolbarActions, { name: "bank" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_1, [
                          _createTextVNode(_toDisplayString(_unref(t)('viia.date_selection')) + " ", 1),
                          _createVNode(HoverInfo, {
                            content: _unref(t)('viia.dato_help')
                          }, null, 8, ["content"])
                        ]),
                        _createVNode(_unref(DatePicker), {
                          modelValue: perDate.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((perDate).value = $event))
                        }, null, 8, ["modelValue"]),
                        _createVNode(_unref(Separator), {
                          orientation: "vertical",
                          class: "hidden h-2.5! md:flex"
                        }),
                        (_ctx.isConnected)
                          ? (_openBlock(), _createBlock(DisconnectBank, {
                              key: 0,
                              "company-id": selectedCompanyId.value
                            }, null, 8, ["company-id"]))
                          : (_ctx.link)
                            ? (_openBlock(), _createBlock(ConnectBank, {
                                key: 1,
                                link: _ctx.link
                              }, null, 8, ["link"]))
                            : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["table-key", "columns", "data", "loading"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})